import { matchPath, useLocation } from 'react-router';
import { ROUTES, IRoute } from '../routes';
import { useMemo } from 'react';

export const useRouteName = (): IRoute => {
  const { pathname } = useLocation();

  function detectRoute(): IRoute {
    if (matchPath({ path: ROUTES.home, end: true }, pathname)) return 'home';

    // Admin
    if (matchPath({ path: ROUTES.admin.root, end: true }, pathname)) return 'admin.root';
    if (matchPath({ path: ROUTES.admin.epp, end: true }, pathname)) return 'admin.epp';
    if (matchPath({ path: ROUTES.admin.users, end: true }, pathname)) return 'admin.users';
    if (matchPath({ path: ROUTES.admin.domains, end: true }, pathname)) return 'admin.domains';
    if (matchPath({ path: ROUTES.admin.subscriptions, end: true }, pathname)) return 'admin.subscriptions';

    // Domains
    if (matchPath({ path: ROUTES.domains.search, end: true }, pathname)) return 'domains.search';
    if (matchPath({ path: ROUTES.domains.transfer, end: true }, pathname)) return 'domains.transfer';
    if (matchPath({ path: ROUTES.domains.prices, end: true }, pathname)) return 'domains.prices';

    // Whois
    if (matchPath({ path: ROUTES.whois, end: true }, pathname)) return 'whois';

    // Hosting
    if (matchPath({ path: ROUTES.hosting.static, end: true }, pathname)) return 'hosting.static';

    // Account
    if (matchPath({ path: ROUTES.account.profile, end: true }, pathname)) return 'account.profile';
    if (matchPath({ path: ROUTES.account.domains, end: true }, pathname)) return 'account.domains';
    if (matchPath({ path: ROUTES.account.domain, end: true }, pathname)) return 'account.domain';
    if (matchPath({ path: ROUTES.account.orders, end: true }, pathname)) return 'account.orders';
    if (matchPath({ path: ROUTES.account.order, end: true }, pathname)) return 'account.order';
    if (matchPath({ path: ROUTES.account.websites, end: true }, pathname)) return 'account.websites';
    if (matchPath({ path: ROUTES.account.website, end: true }, pathname)) return 'account.website';
    if (matchPath({ path: ROUTES.account.websiteDeployments, end: true }, pathname)) return 'account.websiteDeployments';
    if (matchPath({ path: ROUTES.account.websiteDeployment, end: true }, pathname)) return 'account.websiteDeployment';
    if (matchPath({ path: ROUTES.account.websiteDomains, end: true }, pathname)) return 'account.websiteDomains';
    if (matchPath({ path: ROUTES.account.websiteEditor, end: true }, pathname)) return 'account.websiteEditor';
    if (matchPath({ path: ROUTES.account.websiteAnalytics, end: true }, pathname)) return 'account.websiteAnalytics';
    if (matchPath({ path: ROUTES.account.websiteSettings, end: true }, pathname)) return 'account.websiteSettings';

    // Checkout
    if (matchPath({ path: ROUTES.checkout.cart, end: true }, pathname)) return 'checkout.cart';
    if (matchPath({ path: ROUTES.checkout.contact, end: true }, pathname)) return 'checkout.contact';
    if (matchPath({ path: ROUTES.checkout.payment, end: true }, pathname)) return 'checkout.payment';
    if (matchPath({ path: ROUTES.checkout.summary, end: true }, pathname)) return 'checkout.summary';
    if (matchPath({ path: ROUTES.checkout.amountsDue, end: true }, pathname)) return 'checkout.amountsDue';
    if (matchPath({ path: ROUTES.checkout.order, end: true }, pathname)) return 'checkout.order';
    if (matchPath({ path: ROUTES.checkout.result, end: true }, pathname)) return 'checkout.result';

    // Auth
    if (matchPath({ path: ROUTES.auth.root, end: true }, pathname)) return 'auth.root';
    if (matchPath({ path: ROUTES.auth.signin, end: true }, pathname)) return 'auth.signin';
    if (matchPath({ path: ROUTES.auth.signup, end: true }, pathname)) return 'auth.signup';
    if (matchPath({ path: ROUTES.auth.verify, end: true }, pathname)) return 'auth.verify';
    if (matchPath({ path: ROUTES.auth.callback, end: true }, pathname)) return 'auth.callback';
    if (matchPath({ path: ROUTES.auth.reset, end: true }, pathname)) return 'auth.reset';

    // Legal
    if (matchPath({ path: ROUTES.legal.privacyPolicy, end: true }, pathname)) return 'legal.privacyPolicy';
    if (matchPath({ path: ROUTES.legal.terms, end: true }, pathname)) return 'legal.terms';
    if (matchPath({ path: ROUTES.legal.dra, end: true }, pathname)) return 'legal.dra';
    if (matchPath({ path: ROUTES.legal.dpa, end: true }, pathname)) return 'legal.dpa';
    if (matchPath({ path: ROUTES.legal.websiteHostingAgreement, end: true }, pathname)) return 'legal.websiteHostingAgreement';

    return 'unknown'; // Fallback if no route matches
  }

  return useMemo(() => {
    return detectRoute();
  }, [pathname]);
};
